<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col w-full">
        <router-link to="/master">
          <feather-icon icon="ArrowLeftCircleIcon" svgClasses="h-8 w-8" />
        </router-link>
      </div>
      <!-- DESIGNATION FORMS -->
      <div class="vx-col w-full mb-base">
        <DesignationForm v-if="checkPermission(['designation', 'GET'])" />
      </div>

      <div class="vx-col w-full">
        <!-- DESIGNATION LIST -->
        <vs-tabs>
          <vs-tab label="Designation List" icon-pack="feather" icon="icon-box">
            <div class="tab-text">
              <!-- DESIGNATION LIST -->
              <div>
                <DesignationList
                  v-if="checkPermission(['designation', 'POST'])"
                />
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Archive List" icon-pack="feather" icon="icon-box">
            <!-- DESIGNATION ARCHIVE LIST -->
            <div>
              <DesignationList listType="archive" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import DesignationForm from "@/views/apps/masters/designation/DesignationForm.vue";
import DesignationList from "@/views/apps/masters/designation/DesignationList.vue";

export default {
  data() {
    return {
      isActive: false,
      analyticsData: [],
      isImp: false,
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      show: false,
      items: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      nextNum: 10,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
    };
  },
  methods: {
    myFilter: function() {
      this.isActive = !this.isActive;
    },
  },
  components: {
    DesignationForm,
    DesignationList,
  },
};
</script>

<style lang="scss">
#dashboard-analytics {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
